import { ChevronDown, ChevronsUpDown, ChevronUp } from 'lucide-react';
import './TableHeader.css';

const TableHeader = ({
    columns,
    sortColumn,
    sortDirection,
    onSort
}) => {
    const getSortIcon = (columnKey) => {
        if (sortColumn !== columnKey) {
            return <ChevronsUpDown size={14} className="sort-icon-inactive" />;
        }
        return sortDirection === 'asc'
            ? <ChevronUp size={14} className="sort-icon-active" />
            : <ChevronDown size={14} className="sort-icon-active" />;
    };

    return (
        <thead>
            <tr>
                {columns.map((column) => (
                    <th
                        key={column.key}
                        style={{ width: column.width }}
                        className={column.sortable ? 'sortable-header' : ''}
                        onClick={() => column.sortable && onSort(column.key)}
                    >
                        <div className="header-content">
                            <span>{column.label}</span>
                            {column.sortable && getSortIcon(column.key)}
                        </div>
                    </th>
                ))}
            </tr>
        </thead>
    );
};

export default TableHeader;
